import { View, Model } from 'backbone';
import Template from 'dashboard/forms/modal/map-versions-modal.ejs';
import RestService from 'RestService.js';
import BaseTableView from 'properties/BaseTableView.js';
import Constants from 'Constants.js';

class MapVersionsModal extends View {

    initialize(opts) {
        this.options = opts || {};
        this.tagName = 'div';
        this.El = "#mapVersionsModal";
        this.template = Template;
        this._gridEl = Constants.PROP_MAIN_TABLE_MAP_FORM_VERSIONS_VIEW;
        this.defaultGridSize = 0;
        this.emptyRow = { FormVersionId: {}, MajorVersion: {}, MapMajorVersion: {} };
        const _self = this;
        this.model.set({
            colModel: [
                {
                    name: 'FormVersionId',
                    index: 'FormVersionId',
                    editable: false,
                    hidden: true
                },
                {
                    name: 'MajorVersion',
                    index: 'MajorVersion',
                    editable: false,
                    width: 150,
                    minWidth: 150,
                    formatter: 'dropdown'
                },
                {
                    name: 'MapMajorVersion',
                    index: 'MapMajorVersion',
                    editable: true,
                    width: 150,
                    minWidth: 150,
                    edittype: 'select',
                    formatter: 'select',
                    editoptions: { 
                        value: this.getAllVersions(),
                        dataEvents: [
                          {
                            type: 'change',
                            fn: function (e) {
                                _self.enableOKButton();
                                const rowId_colName = e.currentTarget.id.split('_');
                                if (rowId_colName && rowId_colName.length === 2){
                                    _self.saveCell(parseInt(rowId_colName[0]) - 1, rowId_colName[1], $(e.currentTarget).val());
                                }
                            }
                          }
                        ]                    
                    }
                }
            ],
            colNames: ['FormVersionId', 'Version', 'Map to']
        });

        return this;
    }

    bindListEvent() {
        const _self = this;
        $('#btnSetAllToLatest').on("click", (e) => {
            _self.setAllToLatest(e);
        });

        $('#btnClearAll').on("clicK", (e) => {
            _self.clearAll(e);
        });
    }

    unBindListEvent() {
        $('#btnSetAllToLatest').off();
        $('#btnClearAll').off();
    }

    setAllToLatest(e) {
        e.preventDefault();
        e.stopPropagation();
        let gridData = this.model.get('gridData');
        $.each(gridData, (_idx, _item) => {
            _item.MapMajorVersion = '0.00';
        });
        this.loadDataOnGrid();
        this.enableOKButton()
    }

    clearAll(e) {
        e.preventDefault();
        e.stopPropagation();
        let gridData = this.model.get('gridData');
        $.each(gridData, (_idx, _item) => {
            _item.MapMajorVersion = '0.01';
        });
        this.loadDataOnGrid();
        this.enableOKButton()
    }

    getAllVersions() {
        let versions = {
            '0.01': 'None',
            '0.00': 'Latest'
        };

        let gridData = this.model.get('gridData');
        $.each(gridData, (_idx, _item) => {
            versions[_item.MajorVersion] = _item.MajorVersion;
        });

        return versions;

    }

    getUpdatedMapVersions() {
        let _gridData = [];
        let versionList = { VersionList: { Version: [] } };
        if (this.model.get('versionsMapUpdated')) {
            _gridData = this.model.get('gridData');
            $.each(_gridData, (_idx, _item) => {
                if (_item.MapMajorVersion === '0.01') {
                    _item.MapMajorVersion = '';
                }else if (_item.MapMajorVersion === '0.00') {
                    _item.MapMajorVersion = '0';
                }else{
                    _item.MapMajorVersion = parseInt(_item.MapMajorVersion).toString();
                }

                _item.MajorVersion = parseInt(_item.MajorVersion).toString();

                versionList.VersionList.Version.push({ '_FormVersionId': _item.FormVersionId, '_MajorVersion': _item.MajorVersion, '_MapMajorVersion': _item.MapMajorVersion });
            });
        }

        return versionList;
    }

    renderMapVersionsGrid() {
        let self = this;
        $(self._gridEl).jqGrid({
            datatype: "local",
            shrinkToFit: true,
            altRows: true,
            cellEdit: true,
            height: 150,
            width: 225,
            minWidth: 225,
            scrollbar: true,
            gridComplete: function () {
                $(self._gridEl + " tr.jqgrow:odd").css("background", "#DDDDDC");
            },
            resizeStop: (width, index) => {
                self.resizeTableColumns();
            },
            colNames: self.model.get('colNames'),
            colModel: self.model.get('colModel')
        });

        this.loadDataOnGrid();
    }

    enableOKButton() {
        $('.btn-save-map-versions').button({ disabled: false });
        this.model.set('versionsMapUpdated', true);
    }

    saveCell(rowid, cellname, value) {
        var gridData = this.model.get('gridData');
        gridData[rowid][cellname] = value;
        this.model.set('gridData', gridData);
    }

    // Method that renders an scroll in the grid in order to navigate the same on small screens.
    resizeGrid() {
        /*let grid = $(this._gridEl).find('.ui-jqgrid-btable');
        if (grid) {
            grid.each(function (index) {
                let gridId = $(this).attr('id');
                //  If there is no width on parent yet, set a minimum width of 300px
                let gridParentWidth = $('#gbox_' + gridId).parent().width() ? $('#gbox_' + gridId).parent().width() - 20 : 300;
                $('#' + gridId).setGridWidth(gridParentWidth);
            });
        }*/
    }

    loadDataOnGrid() {
        $(this._gridEl).jqGrid("clearGridData");
        let gridData = this.model.get('gridData');
        let actualSize = gridData.length;
        for (let i = 0; i < actualSize; ++i) {
            $(this._gridEl).addRowData(i, gridData[i]);
        }

        if (actualSize < this.defaultGridSize) {
            for (let i = actualSize; i < this.defaultGridSize; ++i) {
                let defaultData = JSON.parse(JSON.stringify(this.emptyRow));
                gridData.push(defaultData);
                $(this._gridEl).addRowData(i, defaultData);
            }
            this.model.set('gridData', gridData);
        }
    }

    removeGrid() {
        $(this._gridEl).jqGrid("clearGridData");
        $(this._gridEl).jqGrid('GridDestroy');
        $(this._gridEl).remove();
    }

    closeModal() {
        $(this.El).remove();
    }

    render() {
        return new Promise((resolve, reject) => {
            $('body').append(this.$el);
            this.$el.html(this.template({}));

            let self = this;
            let height = '500';
            const body = $('body');
            this.dialog = $(self.El).dialog({
                dialogClass: "no-close",
                autoOpen: true, 
                width: 350,
                position: { my: "center", at: "center", of: $('#dashboard-main-panel') },
                
                modal: true,
                resizable: false,
                buttons: [
                    {
                        text: 'OK',
                        'class': 'btn-save-map-versions',
                        'disabled': true,
                        click: () => {
                            this.dialog.dialog("close");
                            resolve(self.getUpdatedMapVersions());
                        }
                    },
                    {
                        text: 'Cancel',
                        'class': 'btn-cancel-map-versions',
                        click: () => {
                            this.dialog.dialog("close");
                            reject('cancel');
                        }
                    }
                ],
                close: () => {
                    self.unBindListEvent();
                    self.removeGrid();
                    this.dialog.dialog("destroy");
                    self.closeModal();
                },
                open: () => {
                    self.bindListEvent();
                    self.renderMapVersionsGrid();
                }
            });

            $('div[role="dialog"]').draggable({ containment: 'body', scroll: false });
            
            this.delegateEvents();

            this.resizeTableColumns();
            return this;
        });
    }

    resizeTableColumns(self = this, reduce = 0) {
        let dialog = $(self.El);
        let grid = $(self._gridEl)
        let width = dialog.width();
        if (width >= 250) { //min dialog widrh
            let columnsWidth = 0;
            grid.find('.jqgfirstrow').children().each((i, e) => {
                if (i > 0) {
                    columnsWidth += $(e).width();
                }
            });
    
            let lastChild =  grid.find('.jqgfirstrow').children().last();
            let getWidth = lastChild.width() + (width - columnsWidth - 10 - reduce);
            $('#propMapFormVersionsTable_MapMajorVersion').width(getWidth);
            lastChild.width(getWidth);
    
            grid.jqGrid("setGridWidth", width - reduce, false); 
        } 
    }
}

export default MapVersionsModal;